import { render } from "./numberPool.vue?vue&type=template&id=f02ca650&scoped=true"
import script from "./numberPool.vue?vue&type=script&lang=js"
export * from "./numberPool.vue?vue&type=script&lang=js"

import "./numberPool.vue?vue&type=style&index=0&id=f02ca650&scoped=true&lang=css"
import "./numberPool.vue?vue&type=style&index=1&id=f02ca650&lang=css"
script.render = render
script.__scopeId = "data-v-f02ca650"

export default script